import {combineEpics} from 'redux-observable';
import {catchError, filter, map, mergeMap, take} from 'rxjs/operators';
import {fetchGlobalTheme} from 'module/Theme/api/ThemeAPI';
import {globalThemeChangedAction} from 'module/Theme/action/ThemeAction';
import {log} from 'common/log';
import {EMPTY, Observable} from 'rxjs';
import {AnyAction} from 'redux';
import {appInitAction} from 'util/ReduxUtil';

const FetchGlobalTheme = (action$: Observable<AnyAction>) => action$.pipe(
	filter(appInitAction.match),
	take(1),
	mergeMap(() => fetchGlobalTheme()),
	map(({data}) => globalThemeChangedAction(data || null)),
	catchError(err => {
		log.error('Global theme fetching failed', err)
		return EMPTY
	}),
);

export const ThemeEpic = combineEpics(FetchGlobalTheme);